export enum FIND_DROP_SCORES_FILTER {
  BY_SCORE,
  BY_HITS,
}

export enum HitScoreName {
  PositiveHit = 'Positive Hit',
  UvPositive = '+',
}

export const scoreGroupTypeOptions = [
  {
    value: 1,
    name: 'All Scores',
  },
  {
    value: 2,
    name: 'Auto Scores',
  },
  {
    value: 3,
    name: 'Manual Scores',
  },
];
